module.exports = __webpack_public_path__ + "static/media/play.87e458b6.svg";